import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M10 10v11', key: 'tkf9cx' }],
  ['path', { d: 'M10 3v1.35', key: '1rsffz' }],
  ['path', { d: 'M14 14v1', key: 'hsexio' }],
  ['path', { d: 'M14 8v.35', key: 'isohmc' }],
  ['path', { d: 'M18 5v7.35', key: '1b0cqo' }],
  ['path', { d: 'M2 10v3', key: '1fnikh' }],
  ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
  ['path', { d: 'M22 10v3', key: '154ddg' }],
  ['path', { d: 'M6 6v11', key: '11sgs0' }],
];

/**
 * @component @name AudioLinesOff
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTB2MTEiIC8+CiAgPHBhdGggZD0iTTEwIDN2MS4zNSIgLz4KICA8cGF0aCBkPSJNMTQgMTR2MSIgLz4KICA8cGF0aCBkPSJNMTQgOHYuMzUiIC8+CiAgPHBhdGggZD0iTTE4IDV2Ny4zNSIgLz4KICA8cGF0aCBkPSJNMiAxMHYzIiAvPgogIDxwYXRoIGQ9Im0yIDIgMjAgMjAiIC8+CiAgPHBhdGggZD0iTTIyIDEwdjMiIC8+CiAgPHBhdGggZD0iTTYgNnYxMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/audio-lines-off
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AudioLinesOff = createLucideIcon('audio-lines-off', __iconNode);

export default AudioLinesOff;
